<template>
  <qx-custom-form
    :noSubBtn="true"
    ref="baseForm"
    :formData="baseForm"
    labelWidth="120px"
  >
    <section slot="validCode" slot-scope="prop">
      <el-input class="inputBox" v-model="prop.form.validCode" placeholder="请输入">
        <img
            class="codeImg cur"
            slot="suffix"
            :src="domain + '/genCode?timestamp=' + otherFormData.validateCodeKey + '&validateCodeKey=' + otherFormData.validateCodeKey"
            v-loading="imgLoading"
            @click="refreshImgCode"
            alt
          />
      </el-input>
    </section>
  </qx-custom-form>
</template>

<script>
import {
  domain,
} from '@/config';
import {
  mapState,
} from 'vuex';
export default {
  data () {
    return {
      domain,
      imgLoading: false,
      otherFormData: {
        validateCodeKey: new Date().getTime(),
      },
      baseForm: {
        form: [
          {
            label: '登录账号',
            value: 'billId',
            type: 'input',
            disabled: true,
            // default: this.userInfo.staffTFInfo.loginAcct,
          },
          {
            label: '原密码',
            value: 'oldPwd',
            type: 'input',
            placeholder: '6-16位字母或数字',
            attr: {
              type: 'password',
            },
          },
          {
            label: '新密码',
            value: 'newPwd',
            type: 'input',
            placeholder: '6-16位字母或数字',
            attr: {
              type: 'password',
            },
          },
          {
            label: '确认密码',
            value: 'comPwd',
            type: 'input',
            placeholder: '6-16位字母或数字',
            attr: {
              type: 'password',
            },
          },
          {
            label: '验证码',
            value: 'validCode',
            slot: true,
          },
        ],
        rules: {
          oldPwd: [ // 原密码
            { required: true, message: '请输入原密码', trigger: 'blur' },
          ],
          newPwd: [ // 新密码
            { required: true, message: '请输入新密码', trigger: 'blur' },
          ],
          comPwd: [ // 确认密码
            { required: true, message: '请输入确认密码', trigger: 'blur' },
          ],
          validCode: [ // 验证码
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {

    // 刷新图形验证码
    async refreshImgCode () {
      this.otherFormData.validateCodeKey = new Date().getTime();
    },
    async sub () {
      let formData = await this.$refs.baseForm.sub();
      if (formData) {
        formData = {
          billId: formData.billId,
          oldPwd: this.encode(formData.oldPwd),
          newPwd: this.encode(formData.newPwd),
          comPwd: this.encode(formData.comPwd),
          validateCodeKey: this.otherFormData.validateCodeKey,
          validCode: formData.validCode,
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    async init (data = {}) {
      this.$nextTick(() => {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: !this.$route.query.id,
          names: ['state', 'customerCode'],
        });
      });
      data.billId = data.billId || this.userInfo.staffTFInfo.loginAcct;
      this.$refs.baseForm.setVal(data);
    },
  },
  mounted () {
    this.$refs.baseForm.setVal('billId', this.userInfo.staffTFInfo.loginAcct);
  },
};
</script>

<style scoped lang="scss">
</style>
